<template>
    <div>
        <transition name="home-fade">
            <component
                :is="view"
            ></component>
        </transition>
    </div>
</template>

<script>
import mainPage from "../pages/home/main.vue";

export default {
    name: "home",

    components: {
		"main-page": mainPage,
	},
    data: () => ({
		view: "main-page"
	}),
    created() {},
    mounted() {},
    watch: {},
    computed: {},
    methods: {}
};
</script>

<style lang="scss" scoped>
</style>
